import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ErrorListProvider} from "../../providers/error-list/error-list";

/**
 * Generated class for the SearchListItemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-search-list-item',
  templateUrl: 'search-list-item.html',
})
export class SearchListItemPage {
  private static MIN_SEARCH_LENGTH: number = 0;

  mode: string;
  minSearchLength = SearchListItemPage.MIN_SEARCH_LENGTH;
  term: string = '';
  isSearching: boolean;
  searchInfoTitle: string = '';
  searchInfoText: string = '';
  searchInfoClass: string = '';
  results: any = [];
  salesOrder: any = {};
  availableLists: any = [];
  placeholder: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private errorListProvider: ErrorListProvider,
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
    this.mode = this.navParams.get('mode');

    if (this.mode == 'NA' || this.mode == 'NA-sub') {
      this.placeholder = "'N001' oder 'Schleifen'";

      for (let list of this.salesOrder.mostly_ok_list_ids) {
        this.availableLists.push(list.mostly_ok_list);
      }
    } else if (this.mode == 'NIO' || this.mode == 'NIO-sub') {
      this.placeholder = "'F001' oder 'Riss'";

      for (let list of this.salesOrder.error_list_ids) {
        this.availableLists.push(list.error_list);
      }
    }

    this.results = this.availableLists;
  }

  ionViewDidEnter() {
  }

  search() {
    this.results = [];

    this.results = this.searchTerm(this.term);
    /*
    if (this.term && this.term.length > 0 && this.term.length < this.minSearchLength) {
      this.searchInfoTitle = 'Unvollständige Suche';
      this.searchInfoText = `Für eine Suche müssen mindestens ${this.minSearchLength} Zeichen eingegeben werden.`;
      this.searchInfoClass = 'bg-warning';
    } else if (!this.term || this.term.length == 0) {
      this.searchInfoTitle = `Suche nach ${this.mode} - Listen`;
      this.searchInfoText = `Geben Sie mindestens ${this.minSearchLength} Zeichen für eine Suche ein.`;
      this.searchInfoClass = 'bg-halflight';
    } else {
      this.searchInfoText = '';
      this.searchInfoTitle = '';
      this.searchInfoClass = '';

      this.searchTerm(this.term);
    }
    */
  }

  searchTerm(term: string) {
    if (term.length == 0)
      return this.availableLists;

    term = term.toLocaleLowerCase();

    let newList = [];

    for (let list of this.availableLists) {
      if (list.error_no.toLowerCase().includes(term) || list.error_name.toLowerCase().includes(term)) {
        newList.push(list);
      }
    }

    return newList;
  }

  /* Old functionality
  private searchTerm(term: string) {
    this.isSearching = true;

    if (this.mode == 'NA' || this.mode == 'NA-sub') {
      this.errorListProvider.searchMostlyOkLists(term).then( data => {
        this.results = data;
        this.isSearching = false;
      });
    } else if (this.mode == 'NIO' || this.mode == 'NIO-sub') {
      this.errorListProvider.searchErrorLists(term).then( data => {
        this.results = data;
        this.isSearching = false;
      });
    }
  }
  */

  selectErrorList(errorList) {
    console.log(errorList);
    this.errorListProvider.selectedErrorList = errorList;

    this.navCtrl.pop();
  }



}



// WEBPACK FOOTER //
// ./src/pages/search-list-item/search-list-item.ts